/* ================================================================
   custom-cart-drawer.js  —  assets/custom-cart-drawer.js
   ================================================================ */

(function () {
  'use strict';

  /* ── Config from Liquid ────────────────────────────────────── */
  var cfg = window.__ccd || {};

  /* ── State ─────────────────────────────────────────────────── */
  var cartData    = null;
  var isOpen      = false;
  var appliedCode = (localStorage.getItem('ccd_coupon') || '').toUpperCase();
  var isLoading   = false;

  /* ── DOM refs ───────────────────────────────────────────────── */
  var drawer       = document.getElementById('ccdDrawer');
  var overlay      = document.getElementById('ccdOverlay');
  var closeBtn     = document.getElementById('ccdCloseBtn');
  var emptyState   = document.getElementById('ccdEmpty');
  var itemsList    = document.getElementById('ccdItemsList');
  var footerEl     = document.getElementById('ccdFooter');

  var couponInputRow   = document.getElementById('ccdCouponInputRow');
  var couponInput      = document.getElementById('ccdCouponInput');
  var couponApplyBtn   = document.getElementById('ccdCouponApplyBtn');
  var couponAppliedRow = document.getElementById('ccdCouponAppliedRow');
  var couponAppliedTxt = document.getElementById('ccdCouponAppliedText');
  var couponRemoveBtn  = document.getElementById('ccdCouponRemoveBtn');
  var couponError      = document.getElementById('ccdCouponError');

  var subtotalVal      = document.getElementById('ccdSubtotalVal');
  var rowProductSave   = document.getElementById('ccdRowProductSave');
  var productSaveLabel = document.getElementById('ccdProductSaveLabel');
  var productSaveVal   = document.getElementById('ccdProductSaveVal');
  var rowCouponSave    = document.getElementById('ccdRowCouponSave');
  var couponSaveLabel  = document.getElementById('ccdCouponSaveLabel');
  var couponSaveVal    = document.getElementById('ccdCouponSaveVal');
  var savingsPill      = document.getElementById('ccdSavingsPill');
  var totalValEl       = document.getElementById('ccdTotalVal');
  var checkoutBtn      = document.getElementById('ccdCheckoutBtn');

  if (!drawer) return;

  /* ── Money formatting ────────────────────────────────────────
     Shopify prices are in paise. ₹999 = 99900 paise.
  ─────────────────────────────────────────────────────────────── */
  function fmt(paise) {
    if (paise == null) return '';
    var rupees  = parseInt(paise, 10) / 100;
    var isWhole = (rupees % 1 === 0);
    return '\u20B9\u00a0' + rupees.toLocaleString('en-IN', {
      minimumFractionDigits: isWhole ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function roundRupee(paise) {
    return Math.round(parseInt(paise, 10) / 100) * 100;
  }

  /* ── Suppress theme's existing mini-cart ─────────────────────
     The theme uses Bootstrap modal + custom .mini-cart classes.
     We hide them whenever our drawer opens.
  ─────────────────────────────────────────────────────────────── */
  function suppressThemeCart() {
    /* 1. Bootstrap modal — close via jQuery if available */
    if (window.jQuery || window.$) {
      var jq = window.jQuery || window.$;
      try {
        jq('.modal.show, .modal.in, #CartDrawer, #mini-cart, #cart-modal').modal('hide');
      } catch (e) {}
    }

    /* 2. Common theme mini-cart selectors — force hidden */
    var themeSelectors = [
      '#CartDrawer',
      '#cart-drawer',
      '#mini-cart',
      '#MiniCart',
      '.mini-cart-modal',
      '.cart-drawer',
      '[data-cart-drawer]',
      '.js-mini-cart'
    ];
    themeSelectors.forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && el !== drawer) {
        el.classList.remove('is-open', 'open', 'active', 'show', 'in');
        el.setAttribute('aria-hidden', 'true');
        el.style.display = 'none';
      }
    });

    /* 3. Remove Bootstrap backdrop if present */
    var backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.parentNode && backdrop.parentNode.removeChild(backdrop);
      document.body.classList.remove('modal-open');
    }
  }

  /* ── Drawer open / close ────────────────────────────────────── */
  function openDrawer() {
    suppressThemeCart();
    if (isOpen) return;
    isOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.body.classList.add('ccd-lock');
    fetchAndRender();
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('ccd-lock');
  }

  /* ── Cart API ────────────────────────────────────────────────── */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { cartData = data; return data; });
  }

  function changeQty(key, qty) {
    if (isLoading) return;
    isLoading = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        cartData  = data;
        isLoading = false;
        render();
        updateCartBadge(data.item_count);
      })
      .catch(function () { isLoading = false; });
  }

  function fetchAndRender() {
    return fetchCart().then(function () {
      render();
      updateCartBadge(cartData ? cartData.item_count : 0);
    });
  }

  /* ── Render ─────────────────────────────────────────────────── */
  function render() {
    if (!cartData) return;
    renderItems(cartData.items);
    renderSummary(cartData);
    renderCouponState();
  }

  /* ── Render items ────────────────────────────────────────────── */
  function renderItems(items) {
    if (!items || items.length === 0) {
      emptyState.style.display  = 'flex';
      itemsList.style.display   = 'none';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    emptyState.style.display  = 'none';
    itemsList.style.display   = 'flex';
    if (footerEl) footerEl.style.display = 'flex';

    itemsList.innerHTML = items.map(function (item) {
      var comparePrice = (item.compare_at_price && item.compare_at_price > item.price)
        ? item.compare_at_price : null;
      var img = item.image
        ? item.image.replace('http://', 'https://').replace(/(\?.*)?$/, '?width=144')
        : '';
      var varTitle = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="ccd-item-variant">' + escHtml(item.variant_title) + '</span>' : '';

      return [
        '<div class="ccd-item" data-key="' + escAttr(item.key) + '">',
          '<a href="' + escAttr(item.url) + '" class="ccd-item-img-link">',
            img
              ? '<img src="' + escAttr(img) + '" alt="' + escAttr(item.product_title) + '" loading="lazy" class="ccd-item-img">'
              : '<div class="ccd-item-img-placeholder"></div>',
          '</a>',
          '<div class="ccd-item-details">',
            '<a href="' + escAttr(item.url) + '" class="ccd-item-name">' + escHtml(item.product_title) + '</a>',
            varTitle,
            '<div class="ccd-item-prices">',
              '<span class="ccd-item-price">' + fmt(item.price) + '</span>',
              comparePrice ? '<s class="ccd-item-compare">' + fmt(comparePrice) + '</s>' : '',
            '</div>',
          '</div>',
          '<div class="ccd-item-right">',
            '<button class="ccd-remove-btn" data-key="' + escAttr(item.key) + '" aria-label="Remove item">',
              '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
                '<polyline points="3 6 5 6 21 6"/>',
                '<path d="M19 6l-1 14H6L5 6"/>',
                '<path d="M10 11v6M14 11v6M9 6V4h6v2"/>',
              '</svg>',
            '</button>',
            '<div class="ccd-qty">',
              '<button class="ccd-qty-btn" data-key="' + escAttr(item.key) + '" data-delta="-1">&#8722;</button>',
              '<span class="ccd-qty-num">' + item.quantity + '</span>',
              '<button class="ccd-qty-btn" data-key="' + escAttr(item.key) + '" data-delta="1">+</button>',
            '</div>',
          '</div>',
        '</div>'
      ].join('');
    }).join('');
  }

  /* ── Render summary ──────────────────────────────────────────── */
  function renderSummary(cart) {
    if (!cart || !cart.items || !cart.items.length) return;

    var compareTotal = 0;
    var actualTotal  = 0;

    cart.items.forEach(function (item) {
      var cp = (item.compare_at_price && item.compare_at_price > item.price)
        ? item.compare_at_price : item.price;
      compareTotal += cp * item.quantity;
      actualTotal  += item.price * item.quantity;
    });

    var productSavings    = compareTotal - actualTotal;
    var productSavingsPct = compareTotal > 0
      ? Math.round(productSavings / compareTotal * 100) : 0;

    var couponDiscount = 0;
    var couponActive   = couponIsActive();

    if (couponActive) {
      var val = parseFloat(cfg.couponValue) || 0;
      couponDiscount = cfg.couponType === 'flat'
        ? val * 100
        : roundRupee(actualTotal * val / 100);
    }

    var finalTotal   = actualTotal - couponDiscount;
    var totalSavings = productSavings + couponDiscount;

    if (subtotalVal) {
      subtotalVal.textContent = fmt(compareTotal > actualTotal ? compareTotal : actualTotal);
    }

    if (rowProductSave) {
      if (productSavings > 0) {
        if (productSaveLabel) productSaveLabel.textContent = 'You Save (' + productSavingsPct + '%)';
        if (productSaveVal)   productSaveVal.textContent   = '\u2212' + fmt(productSavings);
        rowProductSave.style.display = 'flex';
      } else {
        rowProductSave.style.display = 'none';
      }
    }

    if (rowCouponSave) {
      if (couponActive && couponDiscount > 0) {
        if (couponSaveLabel) couponSaveLabel.textContent = 'Coupon (' + appliedCode + ')';
        if (couponSaveVal)   couponSaveVal.textContent   = '\u2212' + fmt(couponDiscount);
        rowCouponSave.style.display = 'flex';
      } else {
        rowCouponSave.style.display = 'none';
      }
    }

    if (savingsPill) {
      if (totalSavings > 0) {
        savingsPill.textContent   = fmt(totalSavings);
        savingsPill.style.display = 'inline-flex';
      } else {
        savingsPill.style.display = 'none';
      }
    }

    if (totalValEl) totalValEl.textContent = fmt(finalTotal);

    if (checkoutBtn) {
      var url = couponActive && appliedCode
        ? '/checkout?discount=' + encodeURIComponent(appliedCode) : '/checkout';
      checkoutBtn.setAttribute('href', url);
    }
  }

  /* ── Coupon ─────────────────────────────────────────────────── */
  function couponIsActive() {
    return appliedCode !== '' &&
      cfg.couponCode &&
      appliedCode === cfg.couponCode.toUpperCase();
  }

  function applyCoupon(code) {
    code = (code || '').trim().toUpperCase();
    hideCouponError();

    if (!code) { showCouponError('Please enter a coupon code.'); return; }
    if (!cfg.couponCode) { showCouponError('No active coupon available.'); return; }
    if (code !== cfg.couponCode.toUpperCase()) {
      showCouponError('Invalid coupon code. Please try again.'); return;
    }

    appliedCode = code;
    localStorage.setItem('ccd_coupon', appliedCode);
    showAppliedState();
    renderSummary(cartData);
  }

  function removeCoupon() {
    appliedCode = '';
    localStorage.removeItem('ccd_coupon');
    showInputState();
    renderSummary(cartData);
  }

  function renderCouponState() {
    if (couponIsActive()) showAppliedState();
    else showInputState();
  }

  function showAppliedState() {
    var label = cfg.couponLabel || (appliedCode + ' applied');
    if (couponAppliedTxt) couponAppliedTxt.textContent = label;
    if (couponInputRow)   couponInputRow.style.display   = 'none';
    if (couponAppliedRow) couponAppliedRow.style.display  = 'flex';
  }

  function showInputState() {
    if (couponInputRow)   couponInputRow.style.display   = 'flex';
    if (couponAppliedRow) couponAppliedRow.style.display  = 'none';
    if (couponInput)      couponInput.value = '';
  }

  function showCouponError(msg) {
    if (couponError) { couponError.textContent = msg; couponError.style.display = 'block'; }
  }
  function hideCouponError() {
    if (couponError) couponError.style.display = 'none';
  }

  /* ── Cart badge update ───────────────────────────────────────── */
  function updateCartBadge(count) {
    var sels = [
      '.cart-count', '.cart__count', '.js-cart-count',
      '[data-cart-count]', '.cart-item-count',
      '.cart-icon-bubble span', '.header__cart-quantity'
    ];
    document.querySelectorAll(sels.join(',')).forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
  }

  /* ── Escape helpers ─────────────────────────────────────────── */
  function escHtml(s) {
    return String(s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
  function escAttr(s) { return escHtml(s); }

  /* ── Event wiring ────────────────────────────────────────────── */

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay)  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  /* Quantity + remove delegation */
  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.ccd-qty-btn[data-key]');
    if (qtyBtn) {
      var key   = qtyBtn.getAttribute('data-key');
      var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
      var item  = cartData && cartData.items.find(function (i) { return i.key === key; });
      if (item) changeQty(key, Math.max(0, item.quantity + delta));
      return;
    }
    var rmBtn = e.target.closest('.ccd-remove-btn[data-key]');
    if (rmBtn) { changeQty(rmBtn.getAttribute('data-key'), 0); return; }
  });

  /* Coupon */
  if (couponApplyBtn) {
    couponApplyBtn.addEventListener('click', function () {
      applyCoupon(couponInput ? couponInput.value : '');
    });
  }
  if (couponInput) {
    couponInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') applyCoupon(couponInput.value);
    });
    couponInput.addEventListener('input', hideCouponError);
  }
  if (couponRemoveBtn) couponRemoveBtn.addEventListener('click', removeCoupon);

  /* ── Cart icon click interception ───────────────────────────────
     KEY RULES:
     1. CAPTURE PHASE (true) — fires before theme's bubble handlers.
     2. For plain <a href="/cart"> links:  ONLY intercept when the
        link is inside header / nav — not "View Cart" footer links.
     3. For specific cart-toggle triggers: always intercept.
     4. stopImmediatePropagation() prevents Bootstrap modal opening.
  ─────────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {

    /* Never touch clicks inside our own drawer */
    if (e.target.closest('#ccdDrawer')) return;

    /* --- Specific non-href cart triggers (always intercept) --- */
    var specificTrigger = e.target.closest([
      '[data-cart-toggle]',
      '[data-cart-open]',
      '.js-cart-toggle',
      '.js-open-cart',
      '.cart-icon-bubble',
      '[data-drawer="cart"]'
    ].join(','));

    if (specificTrigger) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openDrawer();
      return;
    }

    /* --- <a href="/cart"> links: only intercept from header/nav --- */
    var cartLink = e.target.closest('a[href="/cart"], a[href="/cart/"]');
    if (cartLink) {
      /* Check if inside header / nav — if so, open drawer */
      var inHeader = cartLink.closest(
        'header, #header, #shopify-section-header, nav, ' +
        '.site-header, .header, .js-header, ' +
        '.header__icons, .header-wrapper, .nav-bar'
      );
      if (inHeader) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openDrawer();
        return;
      }
      /* Outside header → let the link navigate to the full cart page normally */
    }

  }, true /* capture phase */);

  /* ── Block Bootstrap modal show for cart ────────────────────── */
  document.addEventListener('show.bs.modal', function (e) {
    var id = e.target && (e.target.id || '');
    if (/cart/i.test(id)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
    }
  }, true);

  /* jQuery Bootstrap 3 modal event */
  document.addEventListener('show.bs.modal', function (e) {
    if (e.target && /cart/i.test(e.target.id)) {
      e.stopImmediatePropagation();
    }
  }, true);

  /* ── Global API ──────────────────────────────────────────────── */
  window.openCartDrawer  = openDrawer;
  window.closeCartDrawer = closeDrawer;
  window.refreshCart     = fetchAndRender;

  /* ── Init ────────────────────────────────────────────────────── */
  fetchCart().then(function () {
    updateCartBadge(cartData ? cartData.item_count : 0);
    renderCouponState();
  });

})();

/* ── AGGRESSIVE: Hijack Bootstrap cart modal trigger ────────────
   Added at bottom so it runs after all other scripts load.
   Wraps in setTimeout to ensure Bootstrap has already bound its
   delegated handlers before we remove them.
─────────────────────────────────────────────────────────────── */
(function hijackWhenReady() {
  function hijack() {
    /* Selectors that could be the cart icon trigger */
    var sels = [
      '[data-toggle="modal"][data-target*="art"]',
      '[data-toggle="modal"][data-target*="cart"]',
      '[data-toggle="modal"][data-target*="Cart"]',
      '[data-toggle="modal"][href*="cart"]',
      '[href="#CartDrawer"]',
      '[href="#mini-cart"]',
      '[href="#cart-modal"]',
      '[href="#MiniCart"]'
    ];

    document.querySelectorAll(sels.join(',')).forEach(function (el) {
      if (el.getAttribute('data-ccd-hijacked')) return; // skip if already done

      /* Clone removes ALL existing JS listeners (including Bootstrap) */
      var clone = el.cloneNode(true);
      clone.setAttribute('data-ccd-hijacked', '1');

      /* Strip Bootstrap modal attributes so it can't re-attach */
      ['data-toggle','data-target','data-bs-toggle','data-bs-target'].forEach(function (a) {
        clone.removeAttribute(a);
      });

      /* Replace in DOM */
      if (el.parentNode) el.parentNode.replaceChild(clone, el);

      /* Bind our handler */
      clone.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.openCartDrawer && window.openCartDrawer();
      });
    });

    /* Also bind via jQuery if Bootstrap 3 jQuery events are active */
    if (window.jQuery) {
      var jq = window.jQuery;
      var cartModal = jq('#CartDrawer, #cart-modal, #MiniCart, [id*="CartDrawer"]');
      if (cartModal.length) {
        cartModal.off('show.bs.modal').on('show.bs.modal', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          jq(this).modal('hide');
          window.openCartDrawer && window.openCartDrawer();
          return false;
        });
      }
    }
  }

  /* Run once DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(hijack, 100); /* slight delay so Bootstrap binds first */
    });
  } else {
    setTimeout(hijack, 100);
  }
})();